import type { ReactNode } from "react";
import { Children, Fragment, isValidElement } from "react";

export const getBuilderChildNodes = (children: ReactNode) => {
  const childArray = Children.toArray(children);
  if (
    childArray.length === 1 &&
    isValidElement<{ children?: ReactNode }>(childArray[0]) &&
    childArray[0].type === Fragment
  ) {
    return Children.toArray(childArray[0].props.children);
  }
  return childArray;
};

export const getBuilderChildrenCount = (children: ReactNode) => getBuilderChildNodes(children).length;
